// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination{display:flex;justify-content:center}.pagination .item{display:inline-block;margin:0 5px;height:35px;min-width:35px;text-align:center;line-height:30px;border:1.5px solid #c4c5d0;color:#808198;fill:#808198;border-radius:10px;font-size:16px}.pagination .item.active{border-color:#ff7913;background:#ff7913;color:#fff;fill:#fff}.pagination .item.special{line-height:37px}.pagination .item.border-0{border:0!important}", ""]);
// Exports
module.exports = exports;
